import moment from "moment";
import { deepClone } from "../../framework/core/core";
import { searchTypes } from "../../framework/data/searchTypes";
import { getTemplateForType } from "../../framework/layout";

$.extend(searchTypes, {
    InspectionQuestionChoiceList: {
        entityType: "InspectionQuestionChoiceList",
        searchOptions: ["InspectionQuestionChoiceListName", "Description"],
        columnOrder: [
            "InspectionQuestionChoiceListName",
            "VersionNumber",
            "Description",
            "Notes"
        ],
        filter: "Published eq true and Active eq true",
        sort: "InspectionQuestionChoiceListName asc, VersionNumber desc",
        height: 228
    },
    Call: {
        entityType: "Call",
        sort: "Id desc",
        searchOptions: [
            "CallNumber",
            "Customer.CustomerName",
            "Customer.SortName",
            "CallLine.CallerName"
        ],
        columnOrder: [
            "CallNumber",
            "RelatedOrder/OrderNumber",
            "CallLine[0]/Inbound",
            "CallResolution/CodeNumber",
            "CallLine[0]/CallDateTime",
            "CallLine[0]/Duration",
            "CallLine[0]/CallerName",
            "Customer/CustomerName",
            "Customer/SortName",
            "Reason/CodeNumber",
            "CallPriority/CodeNumber"
        ],
        expand: "Customer, AssignedTo, CallLine, RelatedOrder",
        select:
            "*, AssignedTo/FirstName, RelatedOrder/OrderNumber, AssignedTo/LastName, Customer/CustomerName, CallLine/Inbound, CallLine/CallerName, CallLine/CallDateTime, CallLine/Duration",
        divisions: true,
        regions: true,
        regionsNavigationTypes: "Call"
    },
    CallLine: {
        entityType: "CallLine",
        sort: "Call/Id desc",
        searchOptions: [
            "Call.CallNumber",
            "Call.Customer.CustomerName",
            "Call.Customer.SortName",
            "CallerName"
        ],
        columnOrder: [
            "Call/CallNumber",
            "Call/RelatedOrder/OrderNumber",
            "Inbound",
            "Call/CallResolution/CodeNumber",
            "CallDateTime",
            "Duration",
            "CallerName",
            "Call/Customer/CustomerName",
            "Call/Customer/SortName",
            "Call/Reason/CodeNumber",
            "Call/CallPriority/CodeNumber"
        ],
        expand:
            "Call, Call/Customer, Call/AssignedTo, Call/RelatedOrder, Call/CallPriority",
        select:
            "*, Call/*, Call/AssignedTo/FirstName, Call/RelatedOrder/OrderNumber, Call/AssignedTo/LastName, Call/Customer/CustomerName,Inbound, CallerName,CallDateTime, Duration",
        columns: [
            {
                field: "Call/CallPriority/CodeNumber",
                title: "Priority",
                template: `# var hasColor = false;
                             var status = _.find(z.codes.CallPriority, function(status) {
                                    hasColor = data.Call.CallPriorityId;
                                    return data.Call.CallPriorityId == status.Id;
                                }) || {
                                    CodeNumber: '---'
                                }; 
                                if (hasColor) {
                                   # <span class='display-color-in-grid' style='background-color: #: status.Color #'></span> #
                                }; #
                                <span class='call-order-priority-grid-number'>#: status.CodeNumber #</span>`
            }
        ],
        divisions: true,
        divisionsNavigationTypes: "Call/",
        regions: true,
        regionsNavigationTypes: "Call/Call"
    },
    CallItem: {
        entityType: "CallItem",
        searchOptions: [
            "Call.CallNumber",
            "Call.Customer.CustomerNumber",
            "Call.Customer.CustomerName",
            "Call.Customer.SortName",
            "InventoryNumber",
            "Description",
            "Equipment.SerialNumber.Serial"
        ],
        columnOrder: [
            "Call/CallNumber",
            "Call/Customer/CustomerNumber",
            "Call/Customer/CustomerName",
            "Inventory/InventoryNumber",
            "Description",
            "Equipment/SerialNumber/Serial"
        ],
        expand:
            "Call, Equipment, Call/Customer, Equipment/SerialNumber, Inventory",
        select:
            "*, Equipment/SerialNumber/Serial, Call/CallNumber, Call/Customer/CustomerNumber, Call/Customer/CustomerName, Call/Customer/SortName",
        columns: [
            {
                field: "SerialNumber",
                template:
                    "# var serial = '---';if (data.Equipment && data.Equipment.SerialNumber && data.Equipment.SerialNumber.Serial) { serial = data.Equipment.SerialNumber.Serial;} ##= serial #"
            }
        ],
        divisions: true,
        divisionsNavigationTypes: "Call/",
        regions: true,
        regionsNavigationTypes: "Call/Call"
    },
    TextMacro: {
        entityType: "TextMacro",
        searchOptions: ["MacroName", "MacroDescription"],
        columnOrder: ["MacroName", "MacroDescription"],
        select: "MacroText",
        height: 228
    },
    ShipTo: {
        entityType: "ShipTo",
        searchOptions: [
            "ShipToNumber",
            "ShipToName",
            "Customer.CustomerNumber",
            "Customer.CustomerName"
        ],
        columnOrder: [
            "ShipToNumber",
            "ShipToName",
            "Address1",
            "Address2",
            "Address3",
            "City",
            "Region",
            "PostalCode",
            "Country",
            "Customer/CustomerNumber",
            "Customer/CustomerName"
        ],
        select:
            "ShipToNumber, ShipToName, Address1, Address2, Address3, City, Region, PostalCode, Country, Phone, Email, Ext, ShipViaId, Customer/CustomerNumber, Customer/CustomerName, Customer/DivisionId",
        expand: "Customer",
        height: 228,
        divisions: true,
        regions: true,
        divisionsNavigationTypes: "Customer/",
        regionsNavigationTypes: "ShipTo"
    },
    AddressBook: {
        entityType: "AddressBook",
        searchOptions: ["AddressBookNumber", "AddressBookName"],
        columnOrder: [
            "AddressBookNumber",
            "AddressBookName",
            "Address1",
            "Address2",
            "Address3",
            "City",
            "Region",
            "PostalCode",
            "Country"
        ],
        select:
            "AddressBookNumber, AddressBookName, Address1, Address2, Address3, City, Region, PostalCode, Country, Phone, Email, Ext",
        expand: 0,
        height: 228
    },
    Appointment: {
        entityType: "Appointment",
        columnOrder: [],
        select:
            "Appointment/Order/RelatedCall/ReasonId, Appointment/Order/RelatedCall/CallPriorityId",
        regionsNavigationTypes: ["Order/"]
    },
    Customer: {
        entityType: "Customer",
        searchOptions: [
            "CustomerNumber",
            "CustomerName",
            "SortName",
            "BillTo.ShipTo.Address1",
            "BillTo.ShipTo.Address2",
            "BillTo.ShipTo.City",
            {
                field: "BillTo.ShipTo.Region",
                type: "TextBox"
            },
            "BillTo.ShipTo.PostalCode"
        ],
        columnOrder: [
            "CustomerNumber",
            "CustomerName",
            "SortName",
            "Address1",
            "Address2",
            "City",
            "Region",
            "PostalCode"
        ],
        select: "*",
        expand: "BillTo, BillTo/ShipTo",
        sort: "SortName, CustomerName, CustomerNumber",
        height: 228,
        divisions: true,
        regions: true,
        regionsNavigationTypes: "ShipTo/ShipTo"
    },
    CustomerContact: {
        entityType: "CustomerContact",
        searchOptions: [
            "FirstName",
            "LastName",
            "Customer.CustomerNumber",
            "Customer.CustomerName",
            "Customer.SortName"
        ],
        columnOrder: [
            "Title",
            "FirstName",
            "LastName",
            "Customer/CustomerNumber",
            "Customer/CustomerName",
            "Customer/SortName",
            "ShipTo/ShipToNumber",
            "Location"
        ],
        expand: "Customer, ShipTo",
        select: "*, Customer/*, ShipTo/ShipToNumber",
        regionNotRequired: true,
        divisions: true,
        divisionsNavigationTypes: "Customer/",
        regions: true,
        regionsNavigationTypes: "ShipTo/ShipTo"
    },
    CustomerType: {
        entityTypes: ["CustomerType"],
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value"]
    },
    Equipment: {
        entityType: "Equipment",
        searchOptions: [
            "EquipmentNumber",
            "SerialNumber.Serial",
            "Inventory.InventoryNumber",
            "Description",
            "Site.OwningCustomer.CustomerNumber",
            "Site.OwningCustomer.CustomerName",
            "Site.OwningCustomer.SortName",
            "Site.SiteNumber",
            "Site.SiteName"
        ],
        columnOrder: [
            "EquipmentNumber",
            "SerialNumber/Serial",
            "Inventory/InventoryNumber",
            "Description",
            "Site/OwningCustomer/CustomerNumber",
            "Site/OwningCustomer/CustomerName",
            "Site/OwningCustomer/SortName",
            "Site/SiteNumber",
            "Site/SiteName"
        ],
        expand:
            "Inventory, Site, Site/OwningCustomer, SerialNumber, EquipmentType",
        select:
            "EquipmentNumber, Inventory/InventoryNumber, SerialNumber/Serial, Inventory/InventoryNumber, Description, Site/OwningCustomer/CustomerNumber, Site/OwningCustomer/CustomerName, Site/OwningCustomer/SortName, Site/SiteNumber, Site/SiteName, SiteId, Site/OwningCustomer/DivisionId, Site/ShipTo/ShipToRegionId",
        divisions: true,
        divisionsNavigationTypes: "Site/OwningCustomer/",
        regions: true,
        regionsNavigationTypes: "Site/ShipTo/ShipTo"
    },
    CustomerEquipment: {
        entityType: "CustomerEquipment",
        searchOptions: [
            "Inventory.InventoryNumber",
            "Inventory.Description",
            "Inventory.SortDescription",
            "Description",
            "SerialNumber.Serial",
            "SourceWarehouse.WarehouseName"
        ],
        columnOrder: [
            "Inventory/InventoryNumber",
            "Inventory/Description",
            "Inventory/SortDescription",
            "Description",
            "SerialNumber/Serial",
            "SourceWarehouse/WarehouseName"
        ],
        expand: "Inventory, SerialNumber, SourceWarehouse, Site",
        select:
            "Inventory/InventoryNumber, Inventory/Description, Inventory/SortDescription, Description, SerialNumber/Serial, SourceWarehouse/WarehouseName"
    },
    EquipmentPricing: {
        entityType: "EquipmentPricing",
        searchOptions: ["EquipmentType", "Description"],
        columnOrder: ["EquipmentType", "Description"],
        select: "EquipmentType, Description",
        expand: 0
    },
    Inventory: {
        entityType: "Inventory",
        searchOptions: ["InventoryNumber", "Description", "SortDescription"],
        columnOrder: [
            "InventoryNumber",
            "Description",
            "SortDescription",
            "Serialized",
            "ProductCategory/Value"
        ],
        screenEntityType: "OrderLineInventory",
        select:
            "*, DefaultWarehouse/WarehouseNumber, DefaultVendor/VendorNumber, Warranty/WarrantyNumber, Warranty/PartsPeriod, Warranty/LaborPeriod, EquipmentPricing/EquipmentType",
        expand: "DefaultWarehouse, DefaultVendor, Warranty, EquipmentPricing"
    },
    Task: {
        entityType: "Task",
        searchOptions: ["TaskNumber", "Description"],
        columnOrder: [
            "TaskNumber",
            "Description",
            "SourceWarehouse/WarehouseNumber"
        ],
        screenEntityType: "OrderLineTask",
        select: "*",
        expand: "SourceWarehouse"
    },
    TaskType: {
        entityTypes: ["TaskType"],
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value"]
    },
    Employee: {
        entityType: "Employee",
        searchOptions: [
            "EmployeeNumber",
            "FirstName",
            "LastName",
            "EmailAddress"
        ],
        columnOrder: [
            "EmployeeNumber",
            "FirstName",
            "LastName",
            "EmailAddress"
        ],
        select:
            "EmployeeNumber, FirstName, LastName, EmailAddress, UserId, TelephoneNumber",
        divisions: true,
        regions: true,
        regionsNavigationTypes: "Default"
    },
    ServiceLevelAgreement: {
        entityType: "ServiceLevelAgreement",
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value"],
        select: "CodeNumber, Value"
    },
    ServiceTech: {
        title: "AllTech",
        entityType: "ServiceTech",
        searchOptions: [
            "ServiceTechNumber",
            "ServiceTechName",
            "Employee.FirstName",
            "Employee.LastName",
            "Employee.EmailAddress"
        ],
        columnOrder: [
            "ServiceTechNumber",
            "ServiceTechName",
            "Schedule",
            "Employee/FirstName",
            "Employee/LastName",
            "Employee/EmailAddress"
        ],
        columns: [
            {
                field: "Schedule",
                template:
                `# if (data.Schedule) { #
                    #
                        var url = "Scheduler";
                        var localized = z.ll(url);
                        if (_.includes(z.user.companyData.Rights, 'SCPLBS') && z.util.getBooleanOption("IsSchedulerPlusEnabled", false)) {
                            url = "SchedulerPlus";
                        }
                    #

                    <a href='/#: url #?serviceTechNumber=#= encodeURIComponent(data.ServiceTechNumber) #' target='_blank' class='link'>
                        <span class='grid-url-link'>#: localized #</span>
                    </a>
                #} else { #
                    ---
                # } #`
            }
        ],
        screenEntityType: "OrderLineServiceTech",
        expand: "Employee, SourceWarehouse",
        divisionsNavigationTypes: "Employee/",
        regionsNavigationTypes: "Employee/Default"
    },
    TechType: {
        entityType: "TechType",
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value"]
    },
    Salesperson: {
        entityType: "Salesperson",
        searchOptions: ["SalespersonNumber", "SalespersonName"],
        columnOrder: ["SalespersonNumber", "SalespersonName"]
    },
    Inspection: {
        entityType: "Inspection",
        searchOptions: ["InspectionNumber", "InspectionName"],
        columnOrder: ["InspectionNumber", "InspectionName"],
        screenEntityType: "OrderLineInspection"
    },
    InspectionResult: {
        entityType: "InspectionResult",
        expand: "CompletedTech",
        select: "CompletedTech/ServiceTechName",
        searchOptions: ["CompletedTech.ServiceTechName"],
        columnOrder: [
            "Id",
            "CompletedDateTime",
            "CompletedTech/ServiceTechName"
        ],
        columns: [
            {
                title: "Id",
                field: "Id",
                template:
                    "<a href='/Inspection/?screen=InspectionResults&inspectionResultId=#= data.Id #' target='_blank' class='link'>" +
                    "<span class='grid-orderNumber-link'>#= data.Id #</span>" +
                    "</a>",
                hidden: false
            },
            {
                title: "CompletedDateTime",
                field: "CompletedDateTime",
                hidden: false
            },
            {
                title: "InspectionCompletedBy",
                field: "CompletedTech/ServiceTechName",
                hidden: false
            }
        ]
    },
    SerialNumber: {
        entityType: "SerialNumber",
        searchOptions: ["Serial"],
        columnOrder: ["Serial"],
        select:
            "Serial,Site.OwningCustomer.DivisionId,Site.ShipTo.ShipToRegionId",
        sort: "Serial asc",
        expand: "Site/OwningCustomer,Site/ShipTo",
        divisionsNavigationTypes: "Site/OwningCustomer/",
        divisions: true,
        regions: true,
        regionsNavigationTypes: "Site/ShipTo/ShipTo"
    },
    Order: {
        entityType: "Order",
        searchOptions: [
            "OrderNumber",
            "Customer.CustomerNumber",
            "Customer.CustomerName",
            "Customer.SortName",
            "CustomerPO",
            "OrderStatus"
        ],
        columnOrder: [
            "OrderNumber",
            "OrderStatus/Value",
            "TechOrderStatus",
            "OrderDate",
            "Customer/CustomerNumber",
            "Customer/CustomerName",
            "Customer/SortName",
            "CustomerPO",
            "TotalPrice",
            "RelatedCall/CallNumber",
            "RelatedCall/CallPriority/CodeNumber"
        ],
        expand:
            "RelatedCall, Customer, AssignedTo, Site, RelatedCall/CallPriority",
        select:
            "OrderNumber, RelatedCall.CallNumber, OrderDate, Customer.CustomerNumber, Customer.CustomerName, Customer.SortName, PONumber, TotalPrice, TechOrderStatus, OrderStatusId, RegionId",
        columns: [
            {
                field: "RelatedCall/CallPriority/CodeNumber",
                title: "Priority",
                template: `# var hasColor = false;
                             var status = _.find(z.codes.CallPriority, function(status) {
                                    hasColor = data.RelatedCall.CallPriorityId;
                                    return data.RelatedCall.CallPriorityId == status.Id;
                                }) || {
                                    CodeNumber: '---'
                                }; 
                                if (hasColor) {
                                   # <span class='display-color-in-grid' style='background-color: #: status.Color #'></span> #
                                }; #
                                <span class='call-order-priority-grid-number'>#: status.CodeNumber #</span>`
            }
        ],
        divisions: true,
        regions: true,
        divisionsAndRegionsAndMyStuff: true
    },
    Quote: {
        entityType: "Quote",
        searchOptions: [
            "QuoteNumber",
            "Customer.CustomerNumber",
            "Customer.CustomerName",
            "Customer.SortName",
            "QuoteStatus"
        ],
        columnOrder: [
            "QuoteNumber",
            "QuoteStatus/Value",
            "QuoteDate",
            "Customer/CustomerNumber",
            "Customer/CustomerName",
            "Customer/SortName",
            "TotalPrice"
        ],
        expand: "Customer, Site, AssignedTo",
        select:
            "QuoteNumber, QuoteDate, Customer.CustomerNumber, Customer.CustomerName, Customer.SortName, TotalPrice, QuoteId, RegionId",
        divisions: true,
        regions: true,
        divisionsAndRegionsAndMyStuff: true
    },
    OrderTemplate: {
        entityType: "OrderTemplate",
        searchOptions: ["OrderTemplateNumber", "OrderTemplateName"],
        columnOrder: ["OrderTemplateNumber", "OrderTemplateName", "TotalPrice"],
        select: "OrderTemplateName, OrderTemplateNumber, TotalPrice"
    },
    Shipment: {
        entityType: "Shipment",
        searchOptions: [
            "ShipmentNumber",
            "ShipDate",
            "ShipWeight",
            "TrackingNumber"
        ],
        columnOrder: [
            "ShipmentNumber",
            "ShipDate",
            "ShipWeight",
            "TrackingNumber"
        ],
        select: "ShipmentNumber, ShipDate, ShipWeight, TrackingNumber"
    },
    Invoice: {
        entityType: "Invoice",
        searchOptions: [
            "InvoiceNumber",
            "Order.OrderNumber",
            "Customer.CustomerNumber",
            "Customer.CustomerName",
            "Customer.SortName"
        ],
        columnOrder: [
            "InvoiceNumber",
            "Order/OrderNumber",
            "Customer/CustomerNumber",
            "Customer/CustomerName",
            "Customer/SortName",
            "InvoiceTotal"
        ],
        expand: "Order, Customer",
        select:
            "InvoiceNumber , Order/OrderNumber, InvoiceTotal, Customer/CustomerNumber, Customer/CustomerName",
        sort: "Id desc",
        divisions: true,
        divisionsNavigationTypes: "Order/",
        regions: true,
        regionsNavigationTypes: "Order/",
        divisionsAndRegionsAndMyStuff: true
    },
    Warehouse: {
        entityType: "Warehouse",
        searchOptions: [
            "WarehouseNumber",
            "WarehouseName",
            "Description",
            "Notes"
        ],
        columnOrder: [
            "WarehouseNumber",
            "WarehouseName",
            "Description",
            "Notes"
        ],
        select: "WarehouseNumber, WarehouseName, Description, Notes"
    },
    Warranty: {
        entityType: "Warranty",
        searchOptions: [
            "WarrantyNumber",
            "Description",
            "PartsPeriod",
            "LaborPeriod"
        ],
        columnOrder: [
            "WarrantyNumber",
            "Description",
            "PartsPeriod",
            "LaborPeriod"
        ]
    },
    RepairItem: {
        entityType: "RepairItem",
        searchOptions: [
            "InventoryNumber",
            "Equipment.EquipmentNumber",
            "Description",
            "SerialNumber"
        ],
        columnOrder: [
            "InventoryNumber",
            "Equipment/EquipmentNumber",
            "Description",
            "SerialNumber"
        ],
        expand: "Equipment, Equipment/Inventory",
        select:
            "SerialNumber, InventoryNumber, Description, Equipment/EquipmentNumber"
    },
    QuoteRepairItem: {
        entityType: "QuoteRepairItem",
        searchOptions: [
            "InventoryNumber",
            "Equipment.EquipmentNumber",
            "Description",
            "SerialNumber"
        ],
        columnOrder: [
            "InventoryNumber",
            "Equipment/EquipmentNumber",
            "Description",
            "SerialNumber"
        ],
        select:
            "SerialNumber, InventoryNumber, Description, Equipment/EquipmentNumber",
        expand: "Equipment, Equipment/Inventory"
    },
    PartCausingFailure: {
        entityType: "PartCausingFailure",
        columnOrder: [
            "RepairItem/InventoryNumber",
            "RepairItem/SerialNumber",
            "ServiceTech/ServiceTechName",
            "Inventory/InventoryNumber",
            "Quantity",
            "Notes"
        ],
        columnRenames: {
            "RepairItem/InventoryNumber": "RepairItemInventoryNum",
            "Inventory/InventoryNumber": "PartNumber"
        },
        expand: "RepairItem, Inventory, ServiceTech"
    },
    Report: {
        entityType: "Report",
        searchOptions: ["FileName", "Description"],
        sort: "FileName"
    },
    Right: {
        entityType: "Right",
        searchOptions: ["Description"],
        columnOrder: ["Description"],
        select: "Description",
        columnRenames: {
            Description: "RightDescription"
        }
    },
    RoleRight: {
        entityType: "RoleRight",
        searchOptions: ["Right.RightName", "Right.Description"],
        select: "*,Right/*",
        expand: "RightRole/Right, Right, Role",
        columnRenames: {
            "Right/RightName": "RightName"
        }
    },
    Site: {
        entityType: "Site",
        searchOptions: [
            "SiteNumber",
            "SiteName",
            "OwningCustomer.CustomerNumber",
            "OwningCustomer.CustomerName",
            "OwningCustomer.SortName"
        ],
        columnOrder: [
            "SiteNumber",
            "SiteName",
            "OwningCustomer/CustomerNumber",
            "OwningCustomer/CustomerName",
            "OwningCustomer/SortName"
        ],
        expand: "ShipTo, OwningCustomer, PreferredTech, PreferredTech/Employee",
        select:
            "*, ShipTo/*, OwningCustomer/CustomerNumber, OwningCustomer/CustomerName,OwningCustomer/DivisionId, OwningCustomer/SortName",
        regions: true,
        regionsNavigationTypes: "ShipTo/ShipTo",
        divisions: true,
        divisionsNavigationTypes: "OwningCustomer/"
    },
    TaxCode: {
        entityType: "TaxCode",
        searchOptions: ["TaxCodeNumber", "Description"],
        columnOrder: ["TaxCodeNumber", "Description", "TaxPercent", "State"]
    },
    TaxSchedule: {
        entityType: "TaxSchedule",
        searchOptions: ["TaxScheduleNumber", "TaxScheduleName", "Desciption"],
        columnOrder: ["TaxScheduleNumber", "TaxScheduleName", "Desciption"],
        columnRenames: {
            Desciption: "Description"
        }
    },
    Contract: {
        entityType: "Contract",
        searchOptions: [
            "ContractNumber",
            "RenewalNumber",
            "Customer.CustomerNumber",
            "Customer.CustomerName",
            "Customer.SortName"
        ],
        columnOrder: [
            "ContractNumber",
            "RenewalNumber",
            "ContractStatus/CodeNumber",
            "Customer/CustomerNumber",
            "Customer/CustomerName",
            "Customer/SortName",
            "IsAdvancedPM"
        ],
        expand: "Customer",
        regions: true,
        divisions: true,
        select:
            "ContractNumber, RenewalNumber, Customer/CustomerNumber, Customer/CustomerName",
        columnRenames: {
            IsAdvancedPM: "PreventativeMaintenance"
        }
    },
    SAC: {
        entityType: "SAC",
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value"],
        select: "CodeNumber, Value, SourceWarehouse/WarehouseNumber",
        expand: "SourceWarehouse"
    },
    GLAccount: {
        entityType: "GLAccount",
        searchOptions: [
            "GLAccountNumber",
            "AccountDescription",
            "SearchDescription"
        ],
        columnOrder: [
            "GLAccountNumber",
            "AccountDescription",
            "SearchDescription"
        ],
        select: "GLAccountNumber, AccountDescription, SearchDescription"
    },
    Vendor: {
        entityType: "Vendor",
        searchOptions: ["VendorNumber", "VendorName", "SortName"],
        columnOrder: ["VendorNumber", "VendorName", "SortName"],
        select: "VendorNumber, VendorName, SortName"
    },
    Components: {
        entityType: "Equipment",
        searchOptions: [
            "Inventory.InventoryNumber",
            "Description",
            "SerialNumber.Serial",
            "SourceWarehouse.WarehouseName"
        ],
        select:
            "Inventory.InventoryNumber, Description, SerialNumber.Serial, SourceWarehouse.WarehouseName"
    },
    InventoryWarehouse: {
        entityType: "InventoryWarehouse",
        searchOptions: [
            "Inventory.InventoryNumber",
            "Inventory.Description",
            "Inventory.SortDescription",
            "Warehouse.WarehouseNumber",
            "Warehouse.WarehouseName",
            "QuantityOnHand"
        ],
        columnOrder: [
            "Inventory/InventoryNumber",
            "Inventory/Description",
            "Inventory/SortDescription",
            "Warehouse/WarehouseNumber",
            "Warehouse/WarehouseName",
            "QuantityOnHand"
        ],
        select: "*, Inventory/*, Warehouse/*",
        expand: "Inventory, Warehouse",
        columnRenames: {
            "Inventory/Description": "OrderLineInventory/Description"
        }
    },
    BinInventoryWarehouseOnlyWarehouse: {
        entityType: "InventoryWarehouse",
        searchOptions: ["Warehouse.WarehouseNumber", "Warehouse.WarehouseName"],
        select: "Warehouse/*, NetAvailable",
        expand: "Warehouse"
    },
    AssetCostType: {
        entityType: "AssetCostType",
        searchOptions: [
            "CodeNumber",
            "Value",
            "Warehouse.WarehouseNumber",
            "GLAccount.GLAccountNumber"
        ],
        columnOrder: [
            "CodeNumber",
            "Value",
            "Warehouse/WarehouseNumber",
            "GLAccount/GLAccountNumber"
        ],
        select:
            "CodeNumber, Value, Warehouse.WarehouseNumber, GLAccount.GLAccountNumber",
        expand: "Warehouse, GLAccount"
    },
    SystemUnitOfMeasure: {
        entityType: "SystemUnitOfMeasure",
        searchOptions: ["CodeNumber", "Value"],
        select: "CodeNumber, Value"
    },
    DistinctSerialNumber: {
        entityType: "SerialNumber",
        url: "SerialNumber/GetDistinctSerialNumbers",
        searchOptions: ["SerialNumber"],
        select: "SerialNumber"
    },
    Specialty: {
        entityType: "Specialty",
        searchOptions: ["CodeNumber", "Value", "Length"],
        columnRenames: {
            Value: "Description",
            Length: "CertificationLength"
        }
    },
    Team: {
        entityType: "Team",
        searchOptions: ["CodeNumber", "Value"],
        columnRenames: {
            Value: "Description"
        }
    },
    SubProductCategory: {
        entityType: "SubProductCategory",
        searchOptions: ["CodeNumber", "Value"],
        columnRenames: {
            Value: "Description"
        }
    },
    Role: {
        entityType: "Role",
        searchOptions: ["RoleName", "Description"]
    },
    OrderLine: {
        entityType: "OrderLine",
        columnOrder: [
            "LineNumber",
            "LineType",
            "ItemNumber",
            "Description",
            "Notes"
        ],
        select: "LineNumber, LineType, ItemNumber, Description, Notes"
    },
    QuoteLine: {
        entityType: "QuoteLine",
        columnOrder: [
            "LineNumber",
            "LineType",
            "ItemNumber",
            "Description",
            "Notes"
        ],
        select: "LineNumber, LineType, ItemNumber, Description, Notes"
    },
    OrderSegment: {
        entityType: "OrderSegment"
    },
    QuoteSegment: {
        entityType: "QuoteSegment",
        screenEntityType: "QuoteSegment"
    },
    OrderTemplateSegment: {
        entityType: "OrderTemplateSegment",
        screenEntityType: "OrderTemplateSegment"
    },
    ContractVisitSegment: {
        entityType: "ContractVisitSegment",
        screenEntityType: "ContractVisitSegment"
    },
    OrderTemplateLine: {
        entityType: "OrderTemplateLine",
        columnOrder: [
            "LineNumber",
            "LineType",
            "ItemNumber",
            "Description",
            "Notes"
        ],
        select: "LineNumber, LineType, ItemNumber, Description, Notes"
    },
    TimeZoneCountryCode: {
        entityType: "TimeZoneZones",
        expand: "TimeZoneCountry",
        columnOrder: [
            "TimeZoneCountry/CountryCode",
            "TimeZoneCountry/CountryName"
        ],
        searchOptions: [
            "TimeZoneCountry.CountryCode",
            "TimeZoneCountry.CountryName"
        ],
        select: "TimeZoneCountry/CountryCode, TimeZoneCountry/CountryName",
        columnRenames: {
            "TimeZoneCountry/CountryCode": "CountryCode"
        }
    },
    TimeZoneZones: {
        entityType: "TimeZoneZones",
        columnOrder: ["ZoneName", "CountryCode"],
        searchOptions: ["ZoneName", "CountryCode"],
        select: "ZoneName, CountryCode"
    },
    TimeZoneSettings: {
        entityType: "TimeZoneSettings",
        screenEntityType: "TimeZoneSettings",
        searchOptions: ["TimeZoneZones.ZoneName", "TimeZoneZones.CountryCode"],
        columnOrder: ["TimeZoneZones/ZoneName", "TimeZoneZones/CountryCode"],
        select: "TimeZoneZones.ZoneName, TimeZoneZones.CountryCode",
        expand: "TimeZoneZones"
    },
    TimeZoneCountry: {
        entityType: "TimeZoneCountry",
        searchOptions: [
            "CountryCode",
            "TimeZone.Abbreviation",
            "TimeZone.GMTOffset",
            "ZoneName"
        ],
        columnOrder: [
            "TimeZoneZones/ZoneName",
            "CountryCode",
            "TimeZone/Abbreviation",
            "TimeZone/GMTOffset"
        ],
        select:
            "CountryCode, TimeZone/Abbreviation, TimeZone/GMTOffset, TimeZoneZones/ZoneName",
        expand: "TimeZone, TimeZoneZones",
        sort: "CountryCode  desc"
    },
    Region: {
        entityType: "Region",
        searchOptions: ["RegionNumber", "RegionName"],
        columnOrder: ["RegionNumber", "RegionName"],
        select: "*",
        sort: "RegionName desc",
        codeColumnsToIgnore: ["ParentRegionId", "RegionNumber", "RegionName"]
    },
    EmployeeRegion: {
        entityType: "EmployeeRegion",
        searchOptions: ["Region.RegionNumber", "Region.RegionName"],
        columnOrder: ["Region/RegionNumber", "Region/RegionName"],
        select: "*",
        expand: "Region"
    },
    ContractType: {
        entityType: "ContractType",
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value", "SortOrder"],
        select: "*",
        columnRenames: {
            Value: "Description"
        },
        sort: "SortOrder asc"
    },
    LaborType: {
        entityType: "LaborType",
        searchOptions: ["CodeNumber", "Value"],
        columnOrder: ["CodeNumber", "Value", "Ratio", "Billable"],
        select: "*",
        columnRenames: {
            Value: "Description"
        },
        sort: "SortOrder asc"
    },
    EquipmentMeter: {
        entityType: "EquipmentMeter",
        searchOptions: [
            "EquipmentMeterName",
            "EquipmentMeterNumber",
            "ReadDaysInterval"
        ],
        columnOrder: [
            "EquipmentMeterName",
            "EquipmentMeterNumber",
            "ReadDaysInterval",
            "Equipment/EquipmentNumber",
            "Equipment/Inventory/InventoryNumber"
        ],
        select: "*",
        expand: "Equipment, Equipment/Inventory"
    },
    TimeSlots: {
        entityType: "TimeSlot",
        url: `TimeSlot/GetAvailableTimeSlots?dateTime=${moment().utc()}&range=15`,
        databound: true,
        searchOptions: [
            "Available",
            "Name",
            "TimeZoneZones.ZoneName",
            "CallType.CodeNumber"
        ],
        columnOrder: [
            "Available",
            "Name",
            "Start",
            "TimeZoneZones.ZoneName",
            "CallType.CodeNumber"
        ],
        columns: [
            {
                field: "Start",
                title: "TimeSlot",
                template: `#
                    var start = moment.tz(data.Start, data.TimeZoneZones.ZoneName);
                    var end = moment.tz(data.End, data.TimeZoneZones.ZoneName);
                    var message = start.format("MM/DD/YYYY h:mm A") + " - " + end.format("h:mm A z");
        
                    if (start.date() != end.date()) {
                        var message = start.format("MM/DD/YYYY h:mm A") + " - " + end.format("MM/DD/YYYY h:mm A z");
                    }
                    # #: message #`
            }
        ],
        select: "*, TimeZoneZones/*, CallType/*",
        expand: "TimeZoneZones, CallType"
    },
    TechSpecialty: {
        entityType: "TechSpecialty",
        columnOrder: [
            "ServiceTech/ServiceTechNumber",
            "ServiceTech/ServiceTechName",
            "CertificationDate",
            "ExpirationDate"
        ],
        columns: [
            {
                field: "CertificationDate",
                title: "CertificationDate",
                template: getTemplateForType({
                    type: "Date",
                    field: "CertificationDate"
                })
            },
            {
                field: "ExpirationDate",
                title: "ExpirationDate",
                template: getTemplateForType({
                    type: "Date",
                    field: "ExpirationDate"
                })
            }
        ],
        select: "*",
        expand: "ServiceTech, ServiceTech/Employee"
    },
    Dashboard: {
        entityType: "Dashboard",
        select: "Lookerkey, ScreenId, SortOrder, UserId"
    }
});

searchTypes.ScheduleBoardServiceTechs = deepClone(searchTypes.ServiceTech);
searchTypes.ScheduleBoardServiceTechs.entityType = "ServiceTech";
searchTypes.ScheduleBoardServiceTechs.filter = function () {
    return "Schedule eq true";
};
searchTypes.ScheduleBoardServiceTechs.title = "TechsOnScheduleBoard";

searchTypes.AvailableTimeSlots = deepClone(searchTypes.TimeSlots);
searchTypes.AvailableTimeSlots.EntityType = "TimeSlot";
searchTypes.AvailableTimeSlots.filter = function () {
    return "Available gt 0";
};
searchTypes.AvailableTimeSlots.title = "AvailableTimeSlots";
